export default theme => ({
  root: {
    border: '1px solid lightgrey',
    borderRadius: '3px'
  },
  tableHeader: {
    backgroundColor: theme.palette.common.white,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: 0
  },
  tableSettings: {
    position: 'absolute',
    right: 0,
    top: theme.spacing(-4),
  },
});

